import React from 'react'

import { IconProps } from '../../../common/types'

const BuildingIcon: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 8.6875C3 8.6875 2 9.6875 2 11.6875V19.6875C2 21.6875 3 22.6875 5 22.6875H13M5 8.6875H10M5 8.6875V6.6875C5 5.5875 5.9 4.6875 7 4.6875H10.11C10.03 4.9875 10 5.3175 10 5.6875M10 8.6875V19.6875M10 8.6875V5.6875M10 19.6875C10 21.6875 11 22.6875 13 22.6875M10 19.6875V5.6875M13 22.6875H19C21 22.6875 22 21.6875 22 19.6875V5.6875C22 3.6875 21 2.6875 19 2.6875H13C11 2.6875 10 3.6875 10 5.6875M14 8.6875V13.6875M18 8.6875V13.6875M6 13.6875V17.6875M15 17.6875C14.45 17.6875 14 18.1375 14 18.6875V22.6875H18V18.6875C18 18.1375 17.55 17.6875 17 17.6875H15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default BuildingIcon
